import { CATS, fmt } from '../bamsShortsUtils';

// Free-text SKU / item search across the loaded weeks, with a per-facility breakdown
// for the selected item.
export function SkuLookupPanel({ lookup, lookupQ, setLookupQ, setLookupSel }) {
    return (
        <div className="panel">
            <p className="ptitle">SKU lookup</p>
            <div className="bar" style={{ marginBottom: 8 }}>
                <input
                    type="text"
                    placeholder="Search an item name or SKU — e.g. salmon, 124189, soy"
                    style={{ minWidth: 280, flex: 1 }}
                    value={lookupQ}
                    onChange={(e) => {
                        setLookupQ(e.target.value);
                        setLookupSel(null);
                    }}
                />
                <button
                    type="button"
                    className="ghost"
                    onClick={() => {
                        setLookupQ('');
                        setLookupSel(null);
                    }}
                >
                    Clear
                </button>
            </div>
            {lookup && lookup.needQuery ? (
                <p className="pnote">
                    Type at least two characters. Searches item names and SKU numbers across the current and prior week,
                    every facility and brand.
                </p>
            ) : null}
            {lookup && lookup.empty ? (
                <p className="pnote">Nothing matching “{lookup.q}” was short in the loaded weeks.</p>
            ) : null}
            {lookup && lookup.sel ? (
                <>
                    {lookup.list.length > 1 ? (
                        <div className="bar" style={{ marginBottom: 12 }}>
                            {lookup.list.slice(0, 10).map((x) => (
                                <button
                                    key={x.sku}
                                    type="button"
                                    className="chip nocaps"
                                    aria-pressed={x.sku === lookup.sel.sku}
                                    onClick={() => setLookupSel(x.sku)}
                                >
                                    {x.name || x.sku} <span style={{ opacity: 0.6 }}>{fmt(x.orders)}</span>
                                </button>
                            ))}
                            {lookup.list.length > 10 ? (
                                <span className="sm">+{lookup.list.length - 10} more — narrow the search</span>
                            ) : null}
                        </div>
                    ) : null}
                    <div className="lkname">{lookup.sel.name || lookup.sel.sku}</div>
                    <div className="sm">
                        SKU {lookup.sel.sku} ·{' '}
                        <span style={{ color: CATS[lookup.sel.cat].col, fontWeight: 600 }}>
                            {CATS[lookup.sel.cat].lab}
                        </span>
                    </div>
                    <div className="lkstats">
                        <div>
                            <b>{fmt(lookup.sel.orders)}</b>
                            <span>orders short, both weeks</span>
                        </div>
                        <div>
                            <b>
                                {lookup.sel.rows
                                    .map((r) => r.last)
                                    .sort()
                                    .pop() || '—'}
                            </b>
                            <span>last short (UTC)</span>
                        </div>
                        <div>
                            <b>{Math.max(...lookup.sel.rows.map((r) => r.days))}</b>
                            <span>most days short in a week</span>
                        </div>
                        <div>
                            <b>{new Set(lookup.sel.rows.map((r) => r.facility)).size}</b>
                            <span>facilities affected</span>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th className="item">Facility</th>
                                <th>Brand</th>
                                <th className="n">Week</th>
                                <th className="n">Orders</th>
                                <th className="n">Days</th>
                                <th>Last short (UTC)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...lookup.sel.rows]
                                .sort((a, b) => b.week - a.week || b.orders - a.orders)
                                .map((r, i) => (
                                    <tr key={`${r.facility}|${r.week}|${i}`}>
                                        <td className="item" style={{ fontFamily: 'var(--mono)' }}>
                                            {r.facility}
                                        </td>
                                        <td style={{ fontSize: 11, color: 'var(--muted)' }}>
                                            {r.brand.replace('_', ' ')}
                                        </td>
                                        <td className="n">{r.week}</td>
                                        <td className="n">{fmt(r.orders)}</td>
                                        <td className="n">{r.days}</td>
                                        <td>{r.last}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </>
            ) : null}
        </div>
    );
}
